<div class="bg-main text-white px-4 py-2 flex justify-between items-center">
  <div>
    <img
      src="cmilogo.png"
      [alt]="'common.logoAlt' | translate"
      class="-ml-1 h-12 w-12 cursor-pointer"
      routerLink="/" />
  </div>

  @if (!hideTenantBar()) {
    <div class="flex items-center gap-4 relative flex-1 max-w-md mx-4">
      <div class="flex-1" #dropdownContainer>
        <button
          (click)="toggleDropdown()"
          class="flex items-center gap-2 hover:bg-white/10 p-2 rounded transition-colors w-full text-left"
          type="button"
          [title]="'tenantBar.selectTenantTitle' | translate">
          <span class="flex-1 truncate">
            @if (selectedTenant(); as tenant) {
              {{ tenant.name }}
            } @else {
              {{ 'tenantBar.noTenantSelected' | translate }}
            }
          </span>
          <svg
            class="w-4 h-4 transition-transform shrink-0"
            [class.rotate-180]="isDropdownOpen()"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M19 9l-7 7-7-7" />
          </svg>
        </button>

        @if (isDropdownOpen()) {
          <div
            class="absolute left-0 right-0 mt-2 bg-white text-gray-800 rounded shadow-lg z-50 max-h-64 overflow-y-auto">
            @if (tenants().length > 0) {
              @for (tenant of tenants(); track tenant.name) {
                <button
                  (click)="selectTenant(tenant.name)"
                  class="w-full text-left px-4 py-2 hover:bg-gray-100 transition-colors flex items-center justify-between"
                  type="button"
                  [class.bg-gray-50]="selectedTenant()?.name === tenant.name">
                  <span>{{ tenant.name }}</span>
                  @if (selectedTenant()?.name === tenant.name) {
                    <svg
                      class="w-5 h-5 text-green-600"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor">
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 13l4 4L19 7" />
                    </svg>
                  }
                </button>
              }
            } @else {
              <div class="px-4 py-3 text-gray-500 text-sm">
                {{ 'tenantBar.noTenantsAvailable' | translate }}
              </div>
            }

            <a
              routerLink="/tenants"
              (click)="closeDropdown()"
              class="block border-t border-gray-200 px-4 py-2 text-sm text-main hover:bg-gray-100 transition-colors cursor-pointer">
              {{ 'tenantBar.manageTenants' | translate }}
            </a>
          </div>
        }
      </div>
    </div>
  }

  <div class="flex items-center gap-2">
    <a
      routerLink="/settings"
      class="p-1 hover:bg-white/10 rounded transition-colors cursor-pointer"
      [attr.aria-label]="'settings.title' | translate"
      [title]="'settings.title' | translate">
      <svg class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path
          fill-rule="evenodd"
          d="M7.84 1.804A1 1 0 018.82 1h2.36a1 1 0 01.98.804l.331 1.652a6.993 6.993 0 011.929 1.115l1.598-.54a1 1 0 011.186.447l1.18 2.044a1 1 0 01-.205 1.251l-1.267 1.113a7.047 7.047 0 010 2.228l1.267 1.113a1 1 0 01.206 1.25l-1.18 2.045a1 1 0 01-1.187.447l-1.598-.54a6.993 6.993 0 01-1.929 1.115l-.33 1.652a1 1 0 01-.98.804H8.82a1 1 0 01-.98-.804l-.331-1.652a6.993 6.993 0 01-1.929-1.115l-1.598.54a1 1 0 01-1.186-.447l-1.18-2.044a1 1 0 01.205-1.251l1.267-1.114a7.05 7.05 0 010-2.227L1.821 7.773a1 1 0 01-.206-1.25l1.18-2.045a1 1 0 011.187-.447l1.598.54A6.993 6.993 0 017.51 3.456l.33-1.652zM10 13a3 3 0 100-6 3 3 0 000 6z"
          clip-rule="evenodd" />
      </svg>
    </a>

    <!-- Host specific actions. -->
    <ng-content select="[headerActions]" />

    <button
      (click)="logout()"
      class="p-1 hover:bg-white/10 rounded transition-colors"
      type="button"
      [attr.aria-label]="'logout.title' | translate"
      [title]="'logout.title' | translate">
      <img
        src="logout.svg"
        [alt]="'logout.title' | translate"
        class="size-5 cursor-pointer fill-current" />
    </button>
  </div>
</div>
